/* src/app/shared/components/flow-checkbox/flow-checkbox.component.scss */
.checkbox {
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  box-shadow: 1px 1px 10px 0 rgba(34, 34, 34, 0.06);
  background-color: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  cursor: pointer;
  outline: none;
}
.checkbox.disabled {
  background-color: #f4f4f5;
  cursor: not-allowed;
}
.checkbox.destructive {
  background-color: #fef2f2;
  border: 1px solid #dc2626;
}
.checkbox .check-img {
  width: 14px;
  height: 14px;
  filter: brightness(0) invert(1);
}
.checkbox .check-img.disabled {
  filter: brightness(0) saturate(100%) invert(87.5%);
}
/*# sourceMappingURL=flow-checkbox.component.css.map */
